import Api from "@/services/api.service";
import store from "@/store";

export default {
  getCategoryList() {
    return Api().post("newsCategory/list");
  },
  getNewsFeedList(filter) {
    return Api().get("newsFeed/public/get", { params: filter });
  },
  getNewsFeed(id) {
    return Api().get("newsFeed/public/get/" + id, {
      params: { viewIncrease: true }
    });
  },
  getNewsFeedComments(filter) {
    if (store.state.user.isUserLoggedIn) {
      return Api().get("newsFeed/comment/get", { params: filter });
    } else {
      return Api().get("newsFeed/comment/public/get", { params: filter });
    }
  },
  responseAction(object) {
    return Api().post("newsFeed/comment/action", object);
  },
  deleteRequest(object) {
    return Api().delete(object.path + object.id);
  },
  addComment(object) {
    return Api().post("newsFeed/comment/create", object);
  },
  editComment(object, id) {
    return Api().put("newsFeed/comment/edit/" + id, object);
  }
};
